import React from "react";
import Pagination from "react-bootstrap/Pagination";
import { getPaginationRange, ELLIPSIS } from "../../utils/pagination";

const TablePagination = ({ page, totalPages, onPageChange, className = "mt-4 d-flex justify-content-end" }) => {
  if (!totalPages || totalPages < 1) return null;

  const pageItems = getPaginationRange(page, totalPages);

  return (
    <div className={className}>
      <Pagination>
        <Pagination.First onClick={() => onPageChange(1)} disabled={page === 1} />
        <Pagination.Prev onClick={() => onPageChange(page - 1)} disabled={page === 1} />
        {pageItems.map((item, index) =>
          item === ELLIPSIS ? (
            <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />
          ) : (
            <Pagination.Item key={item} active={page === item} onClick={() => onPageChange(item)}>
              {item}
            </Pagination.Item>
          )
        )}
        <Pagination.Next onClick={() => onPageChange(page + 1)} disabled={page === totalPages} />
        <Pagination.Last onClick={() => onPageChange(totalPages)} disabled={page === totalPages} />
      </Pagination>
    </div>
  );
};

export default TablePagination;
